export const fayzolda = {
    id: "fayzolda",
    name: { ru: "Файзолда Марзия", kz: "Файзолда Марзия" },
    position: { ru: "Медицинская сестра", kz: "Мейіргер" },
    department: "nursing",
    image: "/team_photoes/new/Файзолда Марзия.svg",
    experience: {
      ru: "10 лет",
      kz: "10 жыл"
    },
    education: {
      ru: "Среднее медицинское образование",
      kz: "Орта медициналық білім"
    },
    specialization: {
      ru: "Сестринское дело",
      kz: "Мейіргер ісі"
    },
    certificates: {
      ru: "Сертификаты по сестринскому делу",
      kz: "Мейіргер ісі бойынша сертификаттар"
    },
    work: {
      ru: `• 2018–2020 — КГКП 'Детско-юношеская спортивная школа для спортсменов-инвалидов' г. Астана
• 2020–2023 — 'Даналық' Высший медицинский колледж имени Зои Галымовны Мурзагуловой г. Астана
• 2023 — по настоящее время — Центр спортивной медицины г. Астана`,
      kz: `• 2018–2020 — Астана қаласының 'Балалар және жасөспірімдер мектебі, мүгедек спортшыларға арналған спорт мектебі' КММ
• 2020–2023 — Астана қаласы, Зоя Галымовна Мурзагулова атындағы 'Даналық' Жоғары медициналық колледжі
• 2023 — қазіргі уақытқа дейін — Астана қаласының спорттық медицина орталығында`
    }
  };
